const hexColorRegExp = /^#[0-9a-fA-F]{6}$/;

export const hexToNumber = (hexColor: string) => {
  if (!hexColorRegExp.test(hexColor)) {
    throw Error(`Color must be in #FFFFFF format: Received ${hexColor}`);
  }
  return Number(`0x${hexColor.slice(1)}`);
};

export const hexToVec3 = (hexColor: string) => {
  const number = hexToNumber(hexColor);
  return [
    (((number >> 16) & 255) / 255).toFixed(2),
    (((number >> 8) & 255) / 255).toFixed(2),
    ((number & 255) / 255).toFixed(2)
  ];
};
